export default {"src":"/_next/static/media/icon-info.fe9509d9.svg","height":560,"width":560};